$(document).ready(function () {
    initMethodEvent();
    activateAccordion();
    scrollToSecond();
    clickMethod();
});

function scrollToSecond() {
    if (!window.location.href.includes('#')) {
        return;
    }
    var pos = $(`.butchery-wrapper .second-section`).offset().top;
    window.scrollTo({
        top: pos,
        left: 0,
        behavior: 'smooth'
    });
}

function scrollToSection() {
    if (!window.location.href.includes('#')) {
        return;
    }
    var sectionName = window.location.href.split('#')[1];
    var pos = $(`.butchery-wrapper .second-section .method[data-method="${sectionName}"]`).position().top - 30;
    window.scrollTo({
        top: pos,
        left: 0,
        behavior: 'smooth'
    });
}

function initMethodEvent() {
    $('.fs-container .second-section .right.side .method-title').click(function () {
        var target = $(this).closest('.method');
        if (target.hasClass('active')) {
            target.removeClass('active');
            return;
        }
        scrollToSection();

        target.siblings().removeClass('active');
        target.addClass('active');
    })
}

function activateAccordion() {
    var url = window.location.href;
    var activeLink = url.split('#')
    activeLink = activeLink[activeLink.length - 1];
    var $method = $(`.method[data-method="${activeLink}"]`);
    $method.addClass('active');
    $method.siblings().removeClass('active');
}

function clickMethod() {
    $('.fs-header .butchery-link .page-link').click(function () {
        var method = $(this).closest('.butchery-link').attr('href').split('#')[1];
        var $methodEl = $(`.method[data-method="${method}"]`);
        scrollToSection();
        if ($methodEl.hasClass('active')) {
            return;
        }
        $methodEl.addClass('active');
        $methodEl.siblings().removeClass('active');
    });
}